import * as React from 'react';
import { CsvExportRequest, UpdateCsvExportInput } from '@wooindex/common/types';
import * as fetcher from '@wooindex/common/fetcher';
import ConfirmDialog from '../ConfirmDialog';

type DeleteCsvExportDialogProps = {
  open: boolean
  onClose: (confirmed: boolean) => void
  item: CsvExportRequest
}

export default function DeleteCsvExportDialog ({ open, onClose, item }: DeleteCsvExportDialogProps) {
  const [pending, setPending] = React.useState(false);

  const handleClose = async (confirmed: boolean) => {
    if (!confirmed) {
      onClose(false);
      return;
    }
    try {
      setPending(true);
      await fetcher.put(`/api/csv-exports/${item.id}`, {
        json: { hidden: true } as UpdateCsvExportInput
      });
    } catch (err) {
      // TODO: do we need more error handling than this?
      console.error(err);
      alert('An error occurred trying to delete this export. Please try again later.');
    } finally {
      setPending(false);
      onClose(true);
    }
  };

  return (
    <ConfirmDialog
      title='Remove CSV export?'
      message={`Are you sure you want to remove "${item.name || ''}"? Keep in mind that this action is irreversible.`}
      confirmText='Remove'
      severity='error'
      open={open}
      onClose={handleClose}
      pending={pending}
    />
  );
}
